import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {Outsourced} from "../../Outsourced";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {OutsourcedGameAssets} from "../../OutsourcedGameAssets";
import {RestoreUtils} from "../../utils/RestoreUtils";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreeSpinsIntro implements SimplePresentation {

    name:string = "FreesSpinIntro";

    constructor() {

    }

    public shouldRun():boolean {
        const mode = Outsourced.model.data.mode;
        const nextMode = Outsourced.model.data.nextMode;
        return !Outsourced.model.isRestore &&
               !Outsourced.model.data.brokeTheBank &&
               (mode == GameMode.NORMAL || mode == "NORMAL_RESPIN") && nextMode == GameMode.FREESPIN;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        Outsourced.autoPlayPlugin.turnOffAutoplayOnBonus();
        tl.add(() => {
            controller.setSkipCallback(() => {
                tl.progress(1, false)
            });
        });

        if (Outsourced.model.isRestore)
            tl.add(() => {}, '>0.5');

        tl.add(() => {
            Outsourced.soundPlayer.fadeOutMusic();
        });

        const symbols = Outsourced.reelView.getAllSymbols();
        const isSfs = Outsourced.model.data.freespinsLeft == 5;
        tl.add(Outsourced.soundPlayer.playSoundBased("fsSfsActivation"));
        tl.add(symbols.filter((sym) => sym.symbolName == "SC").map((sym) => sym.getWinBlink()));
        tl.add(symbols.filter((sym) => sym.symbolName == "SC").map((sym) => sym.getWinAnimation()));
        tl.add(<any>Outsourced.keypadPlugin.hide(0.1), '<');

        tl.add(Outsourced.transitionScreen.showFreespinsIntro(Outsourced.model.data.freespinsLeft > 3), '>1.05');
        tl.add(Outsourced.soundPlayer.playSoundBased("fsIntroOneShot"), '<');
        tl.add(Outsourced.soundPlayer.playLoopBased(isSfs ? "sfsIntroLoop" : "fsIntroLoop"), '<');
        if (Outsourced.autoPlayPlugin.isAutoplayRound && Outsourced.model.data.wasFeatureBuy) {
            tl.add(() => {this.onButtonClick(controller)}, '>1.2');
        } else {
            tl.add(Outsourced.transitionScreen.enableButton(() => this.onButtonClick(controller), "continueButtonStartFSSFS"));
        }
        tl.add(() => {controller.setSkipCallback()});
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            Outsourced.reelView.setToFreespins();
            Outsourced.keypadPlugin.setZeroBetSpinCounter(Outsourced.model.data.freespinsLeft);
            Outsourced.keypadPlugin.show(0.1);
        });

        if (Outsourced.model.data.scatterCount == 4)
            tl.add(Outsourced.backgroundElements.setToSuperFreespins(), '<');
        else
            tl.add(Outsourced.backgroundElements.setToFreespins(), '<');
        tl.add(Outsourced.transitionScreen.hideFreespinsIntro(), '<');
        tl.add(() => {
            Outsourced.reelView.disableXBet();
            Outsourced.soundPlayer.switchMusic(GameMode.FREESPIN);
            Outsourced.soundPlayer.fadeInMusic()
        }, '<')
        tl.add(Outsourced.soundPlayer.stopLoopBased("fsIntroLoop"), '<')
        tl.add(Outsourced.soundPlayer.stopLoopBased("sfsIntroLoop"), '<')

        tl.add(() => {
            controller.finish();
            controller.setSkipCallback();
        }, '>0.2');

    }
}

export class FreeSpinsRestoreIntro extends FreeSpinsIntro {
    name:string = "FreeSpinRestoreIntro";

    constructor() {
        super();

    }

    shouldRun(): boolean {
        const mode = Outsourced.model.data.mode;
        const nextMode = Outsourced.model.data.nextMode;
        return Outsourced.model.isRestore &&
               !Outsourced.model.data.brokeTheBank &&
               (mode == GameMode.NORMAL || mode == "NORMAL_RESPIN") && nextMode == GameMode.FREESPIN;
    }
}

export class FreeSpinsIntroActionSpins extends FreeSpinsIntro {
    name:string = "FreeSpinsIntroActionSpins";

    shouldRun(): boolean {
        const mode = Outsourced.model.data.mode;
        const nextMode = Outsourced.model.data.nextMode;
        return RestoreUtils.isActionSpins &&
            (mode == GameMode.NORMAL || mode == "NORMAL_RESPIN") && nextMode == GameMode.FREESPIN;
    }
}